module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":"@:labels.email","emailType":"@:labels.emailType","home":"@:labels.home","invalidEmail":"@:labels.invalidEmail","other":"@:labels.other","work":"@:labels.work"},"fr":{"email":"@:labels.email","emailType":"@:labels.emailType","home":"@:labels.emailType","invalidEmail":"@:labels.invalidEmail","other":"@:labels.other","work":"@:labels.work"}}')
  delete Component.options._Ctor
}
